import { pluralized } from "common/utils/strings";

import { ClientOrderStatus } from "client/orders/types";

import { OrderDashboardSummary } from "../types";

export const getOrderDashboardSummaryBaseContentProps = (
  summary: OrderDashboardSummary,
): { title: string; description: string } => {
  const orderCount = summary.orders.length;
  const ordersPluralized = pluralized(orderCount, "order");
  const toBePluralized = pluralized(orderCount, "is", "are");
  const toBePastPluralized = pluralized(orderCount, "was", "were");
  const toBePresentPerfectPluralized = pluralized(orderCount, "has been", "have been");

  const orderStatus = summary.order_status;

  if (orderStatus === ClientOrderStatus.InProgress) {
    return {
      title: `We're working on your ${ordersPluralized}!`,
      description: `We'll send you updates as your ${ordersPluralized} ${toBePluralized} reviewed by your veterinarian and shipped.`,
    };
  }

  if (orderStatus === ClientOrderStatus.Canceled) {
    if (summary.order_has_client_canceled_items) {
      return {
        title: `Your ${ordersPluralized} ${toBePresentPerfectPluralized} canceled.`,
        description: `You successfully canceled your recent ${ordersPluralized}.`,
      };
    }
    return {
      title: `We're sorry, your ${ordersPluralized} ${toBePresentPerfectPluralized} canceled.`,
      description: `Your ${ordersPluralized} may have been declined by your veterinarian or canceled due to fulfillment issues. Check below for more details.`,
    };
  }

  if (orderStatus === ClientOrderStatus.Completed) {
    return {
      title: `Your ${ordersPluralized} ${toBePluralized} complete!`,
      description: `Your ${ordersPluralized} ${toBePastPluralized} successfully delivered to your door. Thank you for shopping our online store.`,
    };
  }

  return {
    title: `Thank you for your recent ${ordersPluralized}!`,
    description: `We'll send you updates as your ${ordersPluralized} ${toBePluralized} reviewed by your veterinarian and shipped.`,
  };
};
